import Tooltip from '@/ui/Tooltip'
import { Fragment } from 'react'
import { BranchOptionSecondaryButton } from './BranchOptionSecondaryButton'
import { PrimaryButton2ChoicesFiveMobile } from './PrimaryButton2ChoicesFiveMobile'
import { playbookBranchOptionModel } from './playbookBranchOptionModel'
import { getOptionsGridTemplateColumns } from './getOptionsGridTemplateColumns'
import { resolveBranchChoiceDomId } from './resolveBranchChoiceDomId'
import { type PlaybookBranchChoicesGridProps } from './playbookBranchChoicesTypes'

// Mobile layout when three or more plans appear: same dynamic track sizing, kept separate from desktop for tinkering.
export const MobilePlaybookBranchChoicesFive = ({
  nodeId,
  options,
  nextNodeId,
  defaultPrimaryTargetId,
  selectedPath,
  currentPathIndex,
  nodes,
  onSelect,
  onPlanHover,
  onBranchHover,
  expandedPlanLayout,
  onGridMouseLeave,
  showPrimaryHoverStyleByDefault,
}: PlaybookBranchChoicesGridProps) => {
  const branchChoiceElementId = resolveBranchChoiceDomId(nodeId)
  const gridTemplateColumns = getOptionsGridTemplateColumns(options, nodes, expandedPlanLayout)
  return (
    <div
      id={branchChoiceElementId}
      data-branch-choice-ids={options.map(o => o.targetId).filter(Boolean).join(',')}
      className="grid gap-[10px] items-start pb-5"
      style={{ gridTemplateColumns }}
      onMouseLeave={onGridMouseLeave}
    >
      {options.map((option) => {
        const optionProps = {
          option,
          isSelected: nextNodeId === option.targetId || defaultPrimaryTargetId === option.targetId,
          selectedPath,
          currentPathIndex,
          nodes,
          onSelect,
          onPlanHover,
          onBranchHover,
          disableTooltip: expandedPlanLayout,
        }
        const { disableTooltip } = optionProps
        const m = playbookBranchOptionModel(optionProps)
        const button = m.isPrimary ? (
          <PrimaryButton2ChoicesFiveMobile
            option={option}
            targetNode={m.targetNode}
            inverted={m.inverted}
            showHoverStyleByDefault={showPrimaryHoverStyleByDefault}
            onClick={m.handleClick}
            onPointerEnter={m.handlePointerEnter}
            onPointerLeave={m.handlePointerLeave}
          />
        ) : (
          <BranchOptionSecondaryButton
            option={option}
            targetNode={m.targetNode}
            inverted={m.inverted}
            onClick={m.handleClick}
            onPointerEnter={m.handlePointerEnter}
            onPointerLeave={m.handlePointerLeave}
          />
        )
        const choiceKey = option.targetId || 'null'
        if (!m.tooltipContent || disableTooltip) {
          return <Fragment key={choiceKey}>{button}</Fragment>
        }
        return (
          <Tooltip key={choiceKey} content={m.tooltipContent}>
            {button}
          </Tooltip>
        )
      })}
    </div>
  )
}
